import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { HisBaseGlobalsService } from '../../../../core/service/base/his-base-globals.service';

interface BooleanSetting {
    value: boolean;
    label: string;
    helptext?: string;
    required: boolean;
    readonly: boolean;
    name: string;
}
@Component( {
    selector: 'his-boolean-job-setting',
    templateUrl: './his-boolean-job-setting.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
} )
export class HisBooleanJobSettingComponent {
    setting = input.required<BooleanSetting>();
    private baseGlobalService = inject( HisBaseGlobalsService );

    protected title = computed( () => {
        if (this.baseGlobalService.system.operationMode !== 'cust') {
            return '';
        }
        return this.setting().name;
    });
}
